import { VStack, Text } from '@chakra-ui/react';

export default function NotOperatingNotice() {
  return (
    <VStack align="stretch" bgColor="danger.200" px={2} py={4} borderRadius="5px">
      <Text fontSize="sm" fontWeight="bold" color="danger.600">
        未營業
      </Text>
      <Text fontSize="sm" color="danger.600">
        您所選取的取餐時間不符合店家營業時間
      </Text>
    </VStack>
  );
}
